module.exports = __webpack_public_path__ + "img/delete_page.30b09198.svg";